// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_3TmQWDfCK31bzr6cl7ToxV"};